<ul class="side-nav">
  <ng-container *ngFor="let item of menuItems">

    <li *ngIf="item.isTitle" class="side-nav-title">{{ item.label }}</li>

    <ng-container *ngIf="!item.isTitle">
      <!-- menu item without any child -->
      <ng-container *ngIf="!hasSubMenu(item)">
        <ng-container *ngTemplateOutlet="MenuItem;context:{item}" />
      </ng-container>

      <!-- menu item with child -->
      <ng-container *ngIf="hasSubMenu(item)">
        <ng-container *ngTemplateOutlet="MenuItemWithChildren;context:{item}" />
      </ng-container>
    </ng-container>

  </ng-container>
</ul>

<ng-template #MenuItemWithChildren let-item="item">
  <li class="side-nav-item" [ngClass]="{'active': isChildActive(item)}">
    <button (click)="navigateOrToggle(item)" class="side-nav-link"
      [attr.aria-expanded]="!item.isCollapsed">
      <span *ngIf="item.icon" class="menu-icon" [style.color]="item.color">
        <ng-icon [name]="item.icon"></ng-icon>
      </span>
      <span class="menu-text">{{ item.label }}</span>
      <span *ngIf="item.badge" [class]="`badge bg-${item.badge.variant}`">{{ item.badge.text }}</span>
      <span *ngIf="!item.badge" class="menu-arrow">
        <ng-icon [name]="item.isCollapsed ? 'tablerChevronDown' : 'tablerChevronUp'"></ng-icon>
      </span>
    </button>
    <div #collapse="ngbCollapse" [(ngbCollapse)]="item.isCollapsed" class="collapse">
      <ul class="sub-menu">
        <ng-container *ngFor="let child of item.children">
          <!-- menu item without any child -->
          <ng-container *ngIf="!hasSubMenu(child)">
            <ng-container *ngTemplateOutlet="MenuItem;context:{item:child}" />
          </ng-container>

          <!-- menu item with child -->
          <ng-container *ngIf="hasSubMenu(child)">
            <ng-container *ngTemplateOutlet="MenuItemWithChildren;context:{item:child}" />
          </ng-container>
        </ng-container>
      </ul>
    </div>
  </li>
</ng-template>

<ng-template #MenuItem let-item="item">
  <li class="side-nav-item" [ngClass]="{'active': isActive(item)}">
    <a *ngIf="item.url" [routerLink]="item.url" [target]="item.target" class="side-nav-link"
      [ngClass]="{'disabled': item.isDisabled,'special-menu': item.isSpecial, 'active': isActive(item)}"
      [attr.data-active-link]="isActive(item)" (click)="hideBackDrop(item.url)">
      <span *ngIf="item.icon" class="menu-icon" [style.color]="item.color">
        <ng-icon [name]="item.icon"></ng-icon>
      </span>
      <span class="menu-text">{{ item.label }}</span>
      <span *ngIf="item.badge" [ngClass]="`badge text-bg-${item.badge.variant} opacity-50`"
        [innerHTML]="item.badge.text"></span>
    </a>
  </li>
</ng-template>
